<jsg-multi-row-panel>
  <jsg-single-row-panel backgroundStyleClass="section-background-white" first>
    <div first>
      <div>Confirmed hearing date</div>
      <div>{{ hearingDate | date: 'longDate' }}</div>
    </div>
    <div second>
      <div>Hearing time (default)</div>
      <div>{{ hearingTime }}</div>
    </div>
  </jsg-single-row-panel>
  <jsg-single-row-panel second>
    <div first>
      <div>Remedy sought</div>
      <div>{{ remedySought }}</div>
    </div>
  </jsg-single-row-panel>
  <jsg-single-row-panel third>
    <div first>
      <div>Special requirements</div>
      <div
        *ngIf="
          specialRequirementsSelection &&
            specialRequirementsSelection.length === 0;
          else specialRequirementsBlock
        "
        class="section-text"
      >
        ——
      </div>
      <ng-template #specialRequirementsBlock>
        <div *ngFor="let requirement of specialRequirementsSelection">
          <div>
            {{ requirement?.description }}
          </div>
        </div>
      </ng-template>
    </div>
    <div second>
      <div>Other</div>
      <div>{{ specialRequirementNotes | incomplete }}</div>
    </div>
  </jsg-single-row-panel>
  <jsg-single-row-panel fourth>
    <div first>
      <div>Varied deadlines</div>
      <div>{{ variedDeadlines ? 'Yes' : 'No' }}</div>
    </div>
  </jsg-single-row-panel>
  <jsg-single-row-panel
    backgroundStyleClass="section-background-white full-width"
    fifth
  >
    <div first>
      <div></div>
      <div>
        <jsc-hearing-request-documents-view
          [hearingRequestDocuments]="hearingRequestDocuments"
          [displayedColumns]="displayedColumns"
          (openFile)="onOpenFile($event)"
        >
        </jsc-hearing-request-documents-view>
      </div>
    </div>
  </jsg-single-row-panel>
  <jsg-single-row-panel sixth>
    <div first>
      <div>Comments</div>
      <div>{{ comments }}</div>
    </div>
  </jsg-single-row-panel>
</jsg-multi-row-panel>
